import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-view-filter',
  templateUrl: './view-filter.component.html',
  styleUrls: ['./view-filter.component.css']
})
export class ViewFilterComponent implements OnInit {
  @Input() data:any = {}
  @Input() style_conf:any = {}
  show_filter = false
  show_card = false;
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    this.show_card = this.validate_data();
  }
  
  validate_data(){
    let filter_count = 0
    if(this.data['filter_data']){
      for(let i =0; i<this.data['filter_data'].length;i++){
        if(this.data['filter_data'][i]['paramValue']){
          filter_count ++;
        }
        if(this.data['filter_data'][i]['pKey'] == 'multiselect' && Array.isArray(this.data['filter_data'][i]['paramValue'])){
           this.data['filter_data'][i]['paramValue'] = this.data['filter_data'][i]['paramValue']
            .map(innerList => innerList[innerList.length - 1].value)
            .join(';');
        }
      }
    }
    if(filter_count == 0){
      return false
    }
    return true
  }

}
